export default {"src":"/_next/static/media/clearstreet.3c1a482c.svg","height":44,"width":140,"blurWidth":0,"blurHeight":0};